<template>
  <div id="reports" class="wrrapper">
    <page-heading title="Report Templates">
      <template #content>
        <div class="reports flex align-center">
          <Button
            title="Add Template"
            className="button--primary mr-2"
            :onClick="addTemplate"
          />
          <Input
            @enter="handleSearch"
            v-model="searchText"
            type="text"
            placeholder="Search..."
            icon="mdi-magnify"
            :handleSearch="handleSearch"
            :handleReset="handleReset"
            :reset="searchText"
          />
        </div>
      </template>
    </page-heading>
    <div class="content">
      <data-table
        :cols="columns"
        :rows="templateList"
        :loading="loading"
        :pagination="templateList.length > 0"
        :totalPages="pagination.total_pages"
        :resultCount="pagination.total"
        :itemsPerPage="pagination.page_size"
        :currentPage="pagination.page_no"
        :onPageChanged="pageChanged"
      >
        <template slot="action" slot-scope="{ actions }">
          <div class="actions cursor">
            <span
              class="mdi mdi-24px mdi-pencil mr-1 cursor action-icons"
              @click="editTemplate(actions)"
            ></span>
            <span
              class="mdi mdi-24px mdi-delete cursor action-icons"
              @click="deleteTemplate(actions.id)"
            ></span>
          </div>
        </template>
      </data-table>
    </div>
    <modal
      name="templateAdd"
      title="Add Template"
      class="custom-modal"
      height="auto"
      width="80%"
      :adaptive="true"
    >
      <template v-slot:content>
        <div class="add-template">
          <div class="flex align-center space-between">
            <Input
              class="template-title"
              type="text"
              placeholder="Template title"
              v-model="title"
            />
            <div class="flex align-center">
              <Select
                placeholder="Service Head"
                class="mr-2 template-title"
                :options="servicesList"
                :input="handleServices"
              />
              <Button
                title="Save"
                className="button--primary"
                :onClick="saveReport"
              />
            </div>
          </div>
          <TemplateEditor ref="template" height="400" />
        </div>
      </template>
    </modal>
    <Update :report="report" />
  </div>
</template>

<script>
import DataTable from "@/components/DataTable";
import Button from "@/components/Button";
import Input from "@/components/Input";
import Modal from "@/components/Modal";
import TemplateEditor from "@/components/TemplateEditor";
import Select from "@/components/Select";
import Update from "./update";
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    TemplateEditor,
    Update,
    DataTable,
    Select,
    Button,
    Modal,
    Input
  },
  data() {
    return {
      title: "",
      searchText: "",
      lookupId: "",
      report: {},
      columns: [
        { column: "serial", label: "#", width: "60" },
        { column: "name", label: "Template Name", sortable: true, sort: true },
        {
          column: "createdBy",
          label: "Created By",
          sortable: true,
          sort: true
        },
        { column: "action", label: "Action", sortable: true }
      ]
    };
  },
  methods: {
    ...mapActions("reports", [
      "handleTemplateAdd",
      "listTemplates",
      "searchTemplates",
      "templateDelete",
      "getLookupDetails",
      "templateReportsList"
    ]),
    ...mapActions("doctors", ["doctorList"]),
    handleSearch() {
      const query = this.searchText.toLowerCase();
      this.searchTemplates(query);
    },
    addTemplate() {
      this.$modal.show("templateAdd");
      (this.title = ""), (this.report = {});
    },
    saveReport() {
      const report = this.$refs.template.editor.getContents();
      const payload = {
        name: this.title,
        report: report,
        lookupId: this.lookupId
      };
      if (payload.lookupId) {
        this.handleTemplateAdd(payload).then(() => {
          this.templateReportsList("update");
          this.$modal.hide("templateAdd");
        });
      } else {
        this.$toasted
          .show("Please select an service head to add template")
          .goAway("3000");
      }
    },
    pageChanged(val) {
      this.listTemplates(val);
    },
    editTemplate(val) {
      this.report = val && typeof val.report == "object" ? val.report : {};
      this.getLookupDetails(val.id);
      this.$modal.show("templateUpdate");
    },
    deleteTemplate(id) {
      this.templateDelete(id).then(() => {
        this.$toasted.success("Template deleted successfully").goAway("3000");
      });
    },
    handleServices(val) {
      if (val) {
        this.lookupId = val.id;
      }
    },
    handleReset() {
      this.searchText = "";
      this.listTemplates();
    }
  },
  computed: {
    ...mapGetters({
      getTemplates: "reports/getTemplates",
      pagination: "reports/pagination",
      listDoctors: "doctors/listDoctors",
      loading: "loading"
    }),
    templateList() {
      const list = this.getTemplates || [];
      return list.map(item => ({
        ...item,
        createdBy: item.createdBy && item.createdBy.user_name
      }));
    },
    servicesList() {
      return (
        this.listDoctors &&
        this.listDoctors.map(item => ({
          id: item.id,
          name: item.name
        }))
      );
    }
  },
  mounted() {
    this.listTemplates();
    this.doctorList("servicehead");
  }
};
</script>

<style>
#reports .actions .action-icons {
  color: var(--muted-soft);
  transition: color var(--dur) var(--ease);
}
#reports .actions .action-icons:hover {
  color: var(--accent-600);
}
.template-search {
  border: 1px solid var(--line);
  border-radius: var(--radius-md);
}
#reports .template-search input {
  padding: 9px 0 9px 15px;
  border: none;
  margin: 0;
  width: 200px;
}
#reports .footer {
  margin-right: 30px;
}
.add-template {
  padding: 10px 15px;
}
.template-title {
  width: 300px;
}
</style>
